import { QueryKey } from '@/configs/queryKeys';
import {
	ApiPaginatedResponse,
	ApiQueryOptions,
	Attachment,
	CustomFilters,
	Translations,
} from '@/types/types';
import { QueryFunctionContext } from '@tanstack/react-query';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export enum ContentType {
	TEXT,
	IMAGE,
	ELEMENT,
}

export interface Content extends BaseEntity {
	slug: string;
	type: ContentType;
	content: string;
	image: Pick<Attachment, 'id' | 'path'>;
	translations: Translations<{
		content: string;
		image: Pick<Attachment, 'id' | 'path'>;
	}>;
}
class ContentApi extends EntityApi<Content> {
	constructor() {
		super(QueryKey.content);
	}

	override async getAll({
		queryKey,
	}: QueryFunctionContext<
		[
			QueryKey,
			Partial<Pick<ApiQueryOptions<Content>, 'search' | 'sortBy'>>?,
			CustomFilters?,
		]
	>) {
		const params = {
			sortBy: Object.values(queryKey[1]?.sortBy || {}).join(':'),
			limit: -1,
			...queryKey[2],
		};

		const response = await httpClient.get<ApiPaginatedResponse<Content>>(
			queryKey[0],
			{
				params,
				baseURL: 'https://konfigurator-api.wala4doors.com/',
			}
		);

		return response.data.data;
	}
}

export default new ContentApi();
